<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>

    <div style="display: flex;" class="detailsContent">
      <div>
        <div class="detailsTitle">
          <div class="detailsWrap"></div>
          <p>會員賬戶</p>
        </div>

        <el-form v-if="this.type == 0">
          <el-form-item label="會員賬號 ：">
            <input
              maxlength="100"
              @change="userNameChange"
              class="el-input__inner"
              type="text"
              v-model="userInfo.memberAccount"
            />
          </el-form-item>
          <el-form-item v-if="passFlag" label="賬號密碼 ：">
            <input
              maxlength="100"
              class="el-input__inner"
              type="text"
              v-model="memberPasswords"
            />
          </el-form-item>
          <el-form-item label="會員編號 ：">
            <input
              disabled
              maxlength="100"
              class="el-input__inner"
              type="text"
              v-model="id"
            />
          </el-form-item>
        </el-form>
        <el-form v-else>
          <el-form-item label="賬戶狀態 ：">
            <div>{{ type == 1 ? "已注銷" : "已刪除" }}</div>
          </el-form-item>
          <div v-if="type == 2">
            <el-form-item label="刪除時間 ：">
              <div>
                {{ userInfo.deleteTime }}
              </div>
            </el-form-item>
            <el-form-item label="操作人 ：">
              <div>
                {{ userInfo.operator }}
              </div>
            </el-form-item>
          </div>
          <div v-if="type == 1">
            <el-form-item label="注銷時間 ：">
              <div>
                {{ userInfo.deleteTime }}
              </div>
            </el-form-item>
            <el-form-item label="注銷原因 ：">
              <div>
                {{ userInfo.unsubscribeReason }}
              </div>
            </el-form-item>
          </div>
          <el-form-item label="會員賬號 ：">
            <div>
              {{ userInfo.memberAccount }}
            </div>
          </el-form-item>
          <el-form-item label="會員編號 ：">
            <div>
              {{ id }}
            </div>
          </el-form-item>
        </el-form>
        <div>
          <!-- 未认证和审核不通过只显示认证状态，不显示其他信息 -->
          <div class="detailsTitle">
            <div class="detailsWrap"></div>
            <p>實名認證</p>
          </div>
          <el-form>
            <el-form-item label="認證狀態 ：">
              <input
                maxlength="100"
                disabled
                class="el-input__inner blackColor"
                type="text"
                v-model="userInfo.authorization"
              />
            </el-form-item>

            <el-form-item
              label="真實姓名 ："
              v-show="memberStatus === 1 || memberStatus == 2"
            >
              <input
                maxlength="100"
                disabled
                class="el-input__inner blackColor"
                type="text"
                v-model="userInfo.realName"
              />
            </el-form-item>

            <el-form-item
              label="地區 ："
              v-show="memberStatus === 1 || memberStatus == 2"
            >
              <input
                maxlength="100"
                disabled
                class="el-input__inner blackColor"
                type="text"
                v-model="userInfo.region"
              />
            </el-form-item>

            <el-form-item
              label="手機號碼 ："
              v-show="memberStatus === 1 || memberStatus == 2"
            >
              <input
                maxlength="100"
                disabled
                class="el-input__inner blackColor"
                type="text"
                v-model="userInfo.phoneNumber"
              />
            </el-form-item>

            <el-form-item
              label="身份證號碼 ："
              v-show="memberStatus === 1 || memberStatus == 2"
            >
              <input
                v-if="userInfo.idcardNumber == null"
                maxlength="100"
                disabled
                class="el-input__inner blackColor"
                type="text"
                v-model="userInfo.cardNumber"
              />

              <p v-else class="blackColor">
                {{ "+" + userInfo.areaCode + " " + userInfo.cardNumber }}
              </p>
            </el-form-item>

            <div
              v-show="
                (memberStatus === 1 || memberStatus == 2) &&
                  (userInfo.frontImg[0] != null || userInfo.backImg[0] != null)
              "
            >
              <el-form-item label="身份證照片 ：">
                <div class="voucherBlock">
                  <div
                    class="voucherWrap previewFrontImg"
                    v-viewer="{ movable: false }"
                  >
                    <img
                      class="voucherImg"
                      v-for="(src, index) in userInfo.frontImg"
                      :src="src"
                      :key="index"
                      alt=""
                    />
                    <span
                      v-show="userInfo.frontImg[0] != null"
                      @click="previewFrontImg()"
                      >查看大圖</span
                    >
                  </div>

                  <div
                    class="voucherWrap previewBackImg"
                    v-viewer="{ movable: false }"
                  >
                    <img
                      class="voucherImg"
                      v-for="(src, index) in userInfo.backImg"
                      :src="src"
                      :key="index"
                      alt=""
                    />
                    <span
                      v-show="userInfo.backImg[0] != null"
                      @click="previewBackImg()"
                      >查看大圖</span
                    >
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form>

          <div class="bottomBtn" v-if="this.type == 0">
            <div
              v-show="memberStatus === 1"
              class="btn borderBtn auditBtn"
              @click="delAuthInfo()"
            >
              <img src="@/assets/images/common/auditFailed.png" alt="" />
              <p>删除实名认证</p>
            </div>
            <div
              v-show="
                memberStatus !== 1 &&
                  (userInfo.country === '海外' ||
                    userInfo.country === '港澳' ||
                    userInfo.country === '台灣' ||
                    userInfo.country === '臺灣')
              "
              class="btn auditBtn"
              @click="overseaAuthBox()"
            >
              <p>海外用戶實名認證</p>
            </div>
          </div>
        </div>
        <div v-if="this.type == 0">
          <div class="detailsTitle">
            <div class="detailsWrap"></div>
            <p>會員詳情</p>
          </div>

          <el-form>
            <el-form-item label="暱稱 ：">
              <input
                disabled=""
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.nickname"
              />
            </el-form-item>

            <el-form-item label="會員狀態 ：">
              <input
                class="el-input__inner blackColor"
                v-if="userInfo.blackList == 1"
                disabled
                type="text"
                value="黑名單"
              />
              <el-select
                v-else
                v-model="userInfo.vipStatus"
                @change="changeRole"
                placeholder="請選擇會員狀態"
              >
                <el-option label="VIP" value="0"></el-option>
                <el-option label="一般會員" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="會員電話 ：">
              <input
                maxlength="100"
                v-model="userInfo.tel"
                @change="userInfo.tel = userInfo.tel.replace(/\D+/g, '')"
                class="el-input__inner"
                type="text"
              />
            </el-form-item>

            <el-form-item label="郵遞區號 ：">
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.zipCode"
              />
            </el-form-item>

            <el-form-item label="地址 ：">
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.address"
              />
            </el-form-item>

            <el-form-item label="會員生日 ：">
              <el-date-picker
                :picker-options="birthdayOptions"
                v-model="userInfo.birthday"
                type="date"
                placeholder="選擇日期"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="備用郵箱 ：">
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.backupEmail"
              />
            </el-form-item>

            <el-form-item label="備註 ：">
              <input
                placeholder="請輸入備註信息"
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.memo"
              />
            </el-form-item>

            <el-form-item label="VIP起始時間 ：">
              <el-date-picker
                v-model="userInfo.startTime"
                format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="選擇時間"
              ></el-date-picker>
              <span @click="userInfo.startTime = ''" v-if="showReset"
                >重置</span
              >
            </el-form-item>

            <el-form-item label="VIP到期時間 ：">
              <el-date-picker
                v-model="userInfo.endTime"
                 format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="選擇時間"
              ></el-date-picker>
              <span @click="userInfo.endTime = ''" v-if="showReset">重置</span>
            </el-form-item>

            <el-form-item label="會員註冊時間 ：">
              <el-date-picker
                disabled
                v-model="userInfo.createTime"
                format="yyyy-MM-dd HH:mm"
                type="datetime"
                placeholder="選擇時間"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="個性簽名 ：">
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.introduction"
              />
            </el-form-item>

            <el-form-item label="補簽卡數量 ：">
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="userInfo.retroactiveNum"
                disabled=""
              />
            </el-form-item>
            <el-form-item label="入會原因 ：">
              <div
                style="white-space: normal; word-break: break-word;font-size: 14px;line-height: 20px;"
              >
                {{ userInfo.joinReason }}
              </div>
            </el-form-item>
          </el-form>
          <div class="bottomBtn">
            <!-- <div v-show="userInfo.authorizationCode=='1'" class="btn borderBtn" @click="delAuthInfo()">刪除實名認證</div> -->

            <div class="btn" @click="submitModify()">修改</div>
          </div>
        </div>
      </div>
      <div class="box-card" v-if="this.type == 0">
        <div class="cardHeader">
          <div class="cardHeaderLeft">中選記錄</div>
        </div>
        <div class="cardBody" v-if="selectRecord.length">
          <div
            class="cardRow"
            v-for="(item, index) in selectRecord"
            :key="index"
            :style="{
              display: 'block',
              marginTop: index > 0 ? '32px' : '0px'
            }"
          >
            <div class="cardRowRight">{{ item.applyName }}</div>
            <div class="cardRow" style="margin-top:13px">
              <div class="cardRowLeft" style="font-size:0.12rem">
                {{ item.selectedTime }}
              </div>
              <div
                class="cardRowLeft"
                style="font-size:0.12rem;margin-left:24px"
              >
                活動類型：{{
                  item.applyType == "1"
                    ? "一般活動"
                    : item.applyType == "2"
                    ? "演唱會"
                    : item.applyType == "4"
                    ? "見面會"
                    : item.applyType == "3"
                    ? "後臺活動"
                    : ""
                }}
              </div>
            </div>
          </div>
          <div class="paging-block clearfix">
            <el-pagination
              class="paging fr"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="5"
              :pager-count="5"
              layout="prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="cardBody" v-else>
          <div class="cardRow">
            <div class="cardRowLeft">中選記錄：</div>
            <div class="cardRowRight">-</div>
          </div>
        </div>
      </div>
    </div>

    <div class="propWrap" v-if="overseaAuthFlag">
      <div class="prop-content overseasAuth">
        <i
          class="iconfont icon-close fr hand"
          @click="overseaAuthFlag = false"
        ></i>
        <p class="prop-title normal_font">添加海外實名認證</p>
        <div class="auth-box">
          <el-form>
            <el-form-item label="真實姓名 ：">
              <input
                maxlength="100"
                class="el-input__inner blackColor"
                type="text"
                v-model="overseasUser.realName"
                placeholder="請輸入真實姓名"
              />
            </el-form-item>

            <el-form-item label="認證狀態 ：">
              <el-select disabled v-model="overseasUser.authStatus">
                <el-option label="已認證" value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="地區 ：">
              <el-select v-model="overseasUser.area" filterable>
                <el-option
                  v-for="(item, index) in countryData"
                  :label="item.name"
                  :key="index"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="證件號碼 ：">
              <input
                maxlength="100"
                class="el-input__inner blackColor"
                type="text"
                v-model="overseasUser.cardNumber"
                placeholder="請輸入證件號碼"
                @change="
                  overseasUser.cardNumber = overseasUser.cardNumber.replace(
                    /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,
                    ''
                  )
                "
              />
            </el-form-item>

            <el-form-item label="手機號碼 ："
              >+
              <input
                class="el-input__inner blackColor overseasAreaCode"
                maxlength="4"
                type="text"
                @change="phoneChange"
                v-model="overseasUser.overseasCode"
                placeholder="區號"
              />
              <input
                maxlength="100"
                class="el-input__inner blackColor"
                type="text"
                v-model="overseasUser.phoneNumber"
                @change="phoneChange"
                placeholder="請輸入手機號碼"
              />
            </el-form-item>
            <el-form-item label="身份證照片 ：" class="picupload">
              <el-upload
                action=""
                :http-request="uploadRequest"
                :headers="{ Authorization: this.$cookie.get('auth') }"
                :with-credentials="true"
                :on-remove="frontHandleRemove"
                :on-error="errorImage"
                :file-list="overseasUser.frontList"
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :before-upload="beforePicUpload"
                :limit="limit"
                accept=".jpg,.jpeg,.png"
                :multiple="false"
                name="front"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">選擇圖片</el-button>
                <div slot="tip" class="el-upload__tip">支持jpg/png格式</div>
              </el-upload>
              <el-upload
                action=""
                :http-request="uploadRequest"
                :headers="{ Authorization: this.$cookie.get('auth') }"
                :with-credentials="true"
                :on-remove="backHandleRemove"
                :on-error="errorImage"
                :file-list="overseasUser.backList"
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :before-upload="beforePicUpload"
                :limit="limit"
                accept=".jpg,.jpeg,.png"
                :multiple="false"
                name="back"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">選擇圖片</el-button>
                <div slot="tip" class="el-upload__tip">支持jpg/png格式</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div
            class="btn auditBtn"
            style="margin: 0 auto;"
            @click="overseaAuth()"
          >
            <p>認證</p>
          </div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { countryCodeFn } from "@/utils/country.js";
import { reset } from "echarts/lib/visual/seriesColor";

export default {
  data() {
    return {
      navBlock:
        this.$route.query.status == "all"
          ? "訂單  /  所有訂單"
          : this.$route.query.status == "out"
          ? "訂單  /  出貨訂單"
          : this.$route.query.status == "problem"
          ? "訂單  /  問題訂單"
          : this.$route.query.status == "originCode"
          ? "商城  /  溯源碼列表"
          : "會員  /  會員列表",
      navtitle: "會員詳情",
      id: this.$route.query.id,
      authCode: "",
      userInfo: {
        areaCode: "",
        memberAccount: "",
        realName: "",
        authorization: "",
        region: "",
        phoneNumber: "",
        cardNumber: "",
        vipStatus: "",
        blackList: "", //判斷是否為黑名單
        startTime: "",
        endTime: "",
        createTime: "",
        frontImg: [],
        backImg: [],
        birthday: "",
        memo: "",
        country: "", //用於判斷是否為海外用戶
        city: "", // 用於判斷是否為新加坡用戶
        nickname: "", //暱稱
        tel: "", //會員電話
        backupEmail: "", //備用郵箱
        address: "", //地址
        zipCode: "", // 邮编
        introduction: "", //个性签名
        retroactiveNum: "" //补签卡
      },
      overseasUser: {
        realName: "",
        authStatus: "1",
        overseasCode: "", // 海外用戶區號
        area: "",
        cardNumber: "",
        phoneNumber: "",
        frontList: [],
        backList: []
      },
      overseaAuthFlag: false,
      memberStatus: 0,
      currentPage: 1,
      total: 5,
      memberPasswords: "jjlin123456",
      originalAccount: "",
      passFlag: false,
      showReset: false,
      type: 0,
      birthdayOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; // 限制只可以选择今天及今天之前的日期
        }
      },
      limit: 1,
      countryData: [],
      selectRecord: [],
      dialogVisible: false
    };
  },
  created() {
    let _this = this;
    _this.getUserDetails();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    phoneChange() {
      let _this = this;
      _this.overseasUser.phoneNumber = _this.overseasUser.phoneNumber.replace(
        /\D/g,
        ""
      );
    },
    // 获取用户信息详情
    getUserDetails() {
      let _this = this;
      _this
        .$get(
          `/request/member/memberDetial?id=${_this.id}&page=${this.currentPage}&size=5`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            this.type = res.data.type;
            this.total = res.data.allRow;
            _this.showReset =
              res.data.role == "user" && res.data.endTime && res.data.startTime
                ? true
                : false;
            this.selectRecord = res.data.selectedRecord;
            var vipStatus,
              startTime,
              endTime,
              creatTime,
              idCardType,
              authorizationCode;
            vipStatus = res.data.role === "vip" ? "0" : "1";
            startTime =
              res.data.startTime == null
                ? ""
                : res.data.startTime.substring(0, 19);
            endTime =
              res.data.endTime == null ? "" : res.data.endTime.substring(0, 19);
            creatTime =
              res.data.creatTime == null
                ? ""
                : res.data.creatTime.substring(0, 16);
            _this.authCode = res.data.authenticationAreaCode;
            switch (res.data.idcardType) {
              case 1:
                idCardType = "身份證";
                break;
              case 2:
                idCardType = "護照";
                break;
              case 3:
                idCardType = "港澳通行證";
                break;
              case 4:
                idCardType = "台灣通行證";
                break;
              case 5:
                idCardType = "身份證(海外)";
                break;
            }

            //认证状态
            switch (res.data.authorizationCode) {
              case 0:
                authorizationCode = "未認證";
                _this.memberStatus = 0;
                break;
              case 1:
                authorizationCode = "已認證";
                _this.memberStatus = 1;
                break;
              case 2:
                authorizationCode = "待審核";
                _this.memberStatus = 2;
                break;
              case 3:
                authorizationCode = "審核不通過";
                _this.memberStatus = 3;
                break;
            }

            _this.userInfo = {
              areaCode: res.data.areaCode,
              authorizationCode: res.data.authorizationCode,
              memberAccount: res.data.email,
              realName: res.data.realname,
              authorization: authorizationCode,
              // region: res.data.country,
              region: res.data.authenticationAddress,
              phoneNumber:
                "+" + res.data.authenticationAreaCode + " " + res.data.mobile1,
              cardNumber: res.data.idcardNumber,
              blackList: res.data.blackList,
              vipStatus: vipStatus,
              startTime: startTime,
              endTime: endTime,
              createTime: creatTime,
              frontImg: [res.data.frontView],
              backImg: [res.data.backView],
              birthday: res.data.birthday,
              memo: res.data.userMemo,
              country: res.data.country,
              city: res.data.city,
              nickname: res.data.nickname,
              tel: res.data.mobile,
              backupEmail: res.data.backupEmail,
              address: res.data.address,
              zipCode: res.data.zip,
              introduction: res.data.introduction,
              retroactiveNum: res.data.retroactiveNum,
              joinReason: res.data.joinReason,
              unsubscribeReason: res.data.unsubscribeReason,
              deleteTime:res.data.deleteTime? _this.$getTime(res.data.deleteTime):"-",
              operator:res.data.operator,
            };
            _this.originalAccount = res.data.email;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    // 改变角色
    changeRole(val) {
      let _this = this;
      if (val === "1") {
        _this.userInfo.startTime = "";
        _this.userInfo.endTime = "";
      }
    },
    // 会员账号限制输入
    userNameChange(val) {
      let _this = this;
      _this.userInfo.memberAccount = _this.userInfo.memberAccount.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,
        ""
      );
      if (_this.userInfo.memberAccount != _this.originalAccount) {
        _this.passFlag = true;
      }
    },

    // 删除实名认证
    delAuthInfo() {
      let _this = this;
      _this
        .$confirm("確認刪除該賬號的實名認證信息嗎?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$get(
              `/request/authentication/delAuthentication?email=${_this.userInfo.memberAccount}`,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage(
                  "該賬號實名認證信息刪除成功",
                  "success",
                  function() {
                    _this.dialogVisible = false;
                    _this.getUserDetails();
                  }
                );
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    // 审核不通过
    auditFailed() {
      let _this = this;
      let content = "";
      _this
        .$confirm("是否拒絕此用戶認證信息", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$get(
              `/request/authentication/deAuthentication?email=${_this.userInfo.memberAccount}`,
              {},
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = false;
              if (res.code === "00000") {
                _this.$propMessage("操作成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/userInfo");
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },

    // 修改提交
    submitModify() {
      let _this = this;
      let param = {};
      let birthday = null;
      if (_this.userInfo.birthday === "" || _this.userInfo.birthday === null) {
        birthday = null;
      } else {
        birthday =
          typeof _this.userInfo.birthday === "string"
            ? _this.userInfo.birthday
            : _this.$formatDate(_this.userInfo.birthday);
      }
      if (_this.userInfo.memberAccount === "") {
        _this.dialogVisible = true;
        _this.$propMessage("會員賬號不能為空", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }
      if (_this.userInfo.vipStatus === "0") {
        //会员
        if (
          _this.userInfo.startTime === null ||
          _this.userInfo.startTime === ""
        ) {
          _this.dialogVisible = true;
          _this.$propMessage("VIP起始時間不能為空", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          _this.userInfo.startTime =
            typeof _this.userInfo.startTime === "string"
              ? (_this.userInfo.startTime + ":00").substring(0, 19)
              : _this.$formatDate(_this.userInfo.startTime);
        }
        if (_this.userInfo.endTime === null || _this.userInfo.endTime === "") {
          _this.dialogVisible = true;
          _this.$propMessage("VIP到期時間不能為空", "error", function() {
            _this.dialogVisible = false;
          });

          return false;
        } else {
          console.log(typeof _this.userInfo.endTime === "string");
          _this.userInfo.endTime =
            typeof _this.userInfo.endTime === "string"
              ? (_this.userInfo.endTime + ":00").substring(0, 19)
              : _this.$formatDate(_this.userInfo.endTime);
          let timeFormat = _this.$compareTime(
            _this.userInfo.endTime,
            _this.userInfo.startTime
          );
          if (timeFormat == false) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "VIP起始時間不能晚於VIP到期時間",
              "error",
              function() {
                _this.dialogVisible = false;
              }
            );
            return false;
          }
        }

        param = {
          id: _this.id, //用戶id
          role: _this.userInfo.vipStatus === "0" ? "vip" : "user", //是否會員
          // startTime: typeof _this.userInfo.startTime === 'string' ? _this.userInfo.startTime : _this.$formatDate(_this.userInfo.startTime),
          // endTime: typeof _this.userInfo.endTime === 'string' ? _this.userInfo.endTime : _this.$formatDate(_this.userInfo.endTime),
          startTime: _this.userInfo.startTime, //會員開始時間
          endTime: _this.userInfo.endTime, //會員結束時間
          email: _this.userInfo.memberAccount, //用戶帳戶
          birthday: birthday, //生日
          userMemo: _this.userInfo.memo, //備註
          tel: _this.userInfo.tel, //用戶電話
          zip: _this.userInfo.zipCode, //郵政編碼
          address: _this.userInfo.address, //用戶地址
          backupEmail: _this.userInfo.backupEmail, //備用邮箱
          introduction: _this.userInfo.introduction
        };
        if (_this.passFlag) {
          if (_this.memberPasswords === "") {
            _this.dialogVisible = true;
            _this.$propMessage("會員賬號的密碼不能為空", "error", function() {
              _this.dialogVisible = false;
            });
            return false;
          } else {
            param.password = _this.memberPasswords;
          }
        }
      } else if (_this.userInfo.vipStatus === "1") {
        //非会员
        if (
          _this.userInfo.startTime !== null &&
          _this.userInfo.startTime !== ""
        ) {
          _this.userInfo.startTime =
            typeof _this.userInfo.startTime === "string"
              ? (_this.userInfo.startTime + ":00").substring(0, 19)
              : _this.$formatDate(_this.userInfo.startTime);
          if (_this.userInfo.endTime == null || _this.userInfo.endTime == "") {
            _this.$propMessage(
              "vip結束時間不能爲空或重置vip開始時間",
              "error",
              function() {
                _this.dialogVisible = false;
                return;
              }
            );
          }
        } else {
          _this.userInfo.startTime = null;
        }

        if (_this.userInfo.endTime !== null && _this.userInfo.endTime !== "") {
          _this.userInfo.endTime =
            typeof _this.userInfo.endTime === "string"
              ? (_this.userInfo.endTime + ":00").substring(0, 19)
              : _this.$formatDate(_this.userInfo.endTime);
          if (
            _this.userInfo.startTime == null ||
            _this.userInfo.startTime == ""
          ) {
            _this.$propMessage(
              "vip開始時間不能爲空或重置vip結束時間",
              "error",
              function() {
                _this.dialogVisible = false;
                return;
              }
            );
          }
        } else {
          _this.userInfo.endTime = null;
        }

        if (
          _this.userInfo.startTime !== null &&
          _this.userInfo.startTime !== "" &&
          _this.userInfo.endTime !== null &&
          _this.userInfo.endTime !== ""
        ) {
          let timeFormat = _this.$compareTime(
            _this.userInfo.endTime,
            _this.userInfo.startTime
          );
          if (timeFormat == false) {
            _this.dialogVisible = true;
            _this.$propMessage(
              "VIP起始時間不能晚於VIP到期時間",
              "error",
              function() {
                _this.dialogVisible = false;
              }
            );
            return false;
          }
        }
        param = {
          id: _this.id, //用戶id
          role: _this.userInfo.vipStatus === "0" ? "vip" : "user", //是否會員
          startTime: _this.userInfo.startTime, //會員開始時間
          endTime: _this.userInfo.endTime, //會員結束時間
          email: _this.userInfo.memberAccount, //用戶帳戶
          birthday: birthday, //生日
          userMemo: _this.userInfo.memo, //備註
          tel: _this.userInfo.tel, //用戶電話
          zip: _this.userInfo.zipCode, //郵政編碼
          address: _this.userInfo.address, //用戶地址
          backupEmail: _this.userInfo.backupEmail, //備用油箱
          introduction: _this.userInfo.introduction
          // creatTime:_this.userInfo.createTime//會員創建時間
        };
        if (_this.passFlag) {
          if (_this.memberPasswords === "") {
            _this.dialogVisible = true;
            _this.$propMessage("會員賬號的密碼不能為空", "error", function() {
              _this.dialogVisible = false;
            });
            return false;
          } else {
            param.password = _this.memberPasswords;
          }
        }
      }

      _this
        .$confirm("確定修改此用戶詳情?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$post(
              "/request/member/alterMemberDetial",
              param,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("用戶詳情修改成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.$router.push("/userInfo");
                });
              } else if (res.code === "40002") {
                if (res.data === "包含非法字符") {
                  _this.$propMessage(
                    "輸入內容不能包含非法字符，請重試",
                    "error",
                    function() {
                      _this.dialogVisible = false;
                    }
                  );
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    // 预览身份证正面照
    previewFrontImg() {
      let _this = this;
      const frontViewer = _this.$el.querySelector(".previewFrontImg").$viewer;
      frontViewer.show();
    },
    // 预览身份证反面照
    previewBackImg() {
      let _this = this;
      const backViewer = _this.$el.querySelector(".previewBackImg").$viewer;
      backViewer.show();
    },
    // 海外用户实名认证
    overseaAuthBox() {
      this.overseaAuthFlag = true;
      this.countryData = countryCodeFn();
    },
    overseaAuth() {
      let _this = this;
      console.log(_this.overseasUser.area);
      if (
        _this.overseasUser.realName === "" ||
        _this.$getCaption(_this.overseasUser.realName)
      ) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "真實姓名不能為空或者含有非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );

        return false;
      }
      if (_this.overseasUser.area === "") {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇地區", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }
      if (
        _this.overseasUser.cardNumber === "" ||
        _this.$getCaption(_this.overseasUser.cardNumber)
      ) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "證件號碼不能為空或者含有非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );

        return false;
      }
      if (
        _this.overseasUser.overseasCode === "" ||
        _this.$getCaption(_this.overseasUser.overseasCode)
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("區號不能為空或者含有非法字符", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (
        _this.overseasUser.phoneNumber === "" ||
        _this.$getCaption(_this.overseasUser.phoneNumber)
      ) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "手機號碼不能為空或者含有非法字符",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );

        return false;
      }
      // 新加坡用户可以不上传身份证
      if (_this.overseasUser.area !== "新加坡") {
        if (
          _this.overseasUser.frontList.length === 0 ||
          _this.overseasUser.backList.length === 0
        ) {
          _this.dialogVisible = true;
          _this.$propMessage("請上傳身份證照片", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      let param = {
        id: _this.id,
        email: _this.userInfo.memberAccount,
        realName: _this.overseasUser.realName,
        codeType: 2, //護照
        address: _this.overseasUser.area,
        idCode: _this.overseasUser.cardNumber,
        authorizationCode: 1,
        mobile: _this.overseasUser.phoneNumber,
        areaCode: _this.overseasUser.overseasCode,
        frontView:
          _this.overseasUser.frontList.length === 1
            ? _this.overseasUser.frontList[0].url
            : null,
        backView:
          _this.overseasUser.backList.length === 1
            ? _this.overseasUser.backList[0].url
            : null
      };
      console.log(param);
      _this
        .$post(
          "/request/authentication/addOverSeaBankAuth2",
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.$propMessage("添加海外實名認證成功", "success", function() {
              _this.dialogVisible = false;
              _this.overseaAuthFlag = false;
              _this.getUserDetails();
            });
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserDetails();
    },
    // 上传图片之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片只能是jpg或者png格式", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過2MB!", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          if (img.width > 3000 || file.size > 1024 * 1024) {
            _this.$imageConversion
              .compress(file, {
                quality: 0.3,
                width: 3000
              })
              .then(res => {
                resolve(res);
              });
          } else {
            resolve(file);
          }
        };
        img.src = _URL.createObjectURL(file);
      });
      return isJPG && isLt2M && isWidth;
    },
    // 上传图片
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                if (val.res.statusCode === 200) {
                  if (option.filename === "front") {
                    //身分證正面
                    self.overseasUser.frontList.push({
                      name: "img.jpg",
                      url: self.$GLOBAL.picFileUrl + val.name
                    });
                    //cdn预热
                    self
                      .$cdnFun(self.overseasUser.frontList[0].url)
                      .then(res => {
                        console.log(res);
                      });
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                  } else if (option.filename === "back") {
                    // 列表主图竖图
                    self.overseasUser.backList.push({
                      name: "img.jpg",
                      url: self.$GLOBAL.picFileUrl + val.name
                    });
                    //cdn预热
                    self
                      .$cdnFun(self.overseasUser.backList[0].url)
                      .then(res => {
                        console.log(res);
                      });
                    document.getElementsByClassName(
                      "el-upload"
                    )[1].style.display = "none";
                  }
                  return val;
                } else {
                  option.onError("上传失败1");
                }
              },
              err => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    // 移除图片的回调函数
    frontHandleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.overseasUser.frontList);
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    // 图片上传成功的回调函数
    // frontSuccessImage (res) {
    //   let _this = this;
    //   _this.overseasUser.frontList.push({name: 'img.jpg', url: res.msg});
    //   document.getElementsByClassName('el-upload')[0].style.display = 'none';

    // },
    // 移除图片的回调函数
    backHandleRemove(file, fileList) {
      let _this = this;
      _this.$deleteUidItem(file.uid, _this.overseasUser.backList);
      document.getElementsByClassName("el-upload")[1].style.display =
        "inline-block";
    },
    // 图片上传成功的回调函数
    // backSuccessImage (res) {
    //   let _this = this;
    //   _this.overseasUser.backList.push({name: 'img.jpg', url: res.msg});
    //   document.getElementsByClassName('el-upload')[1].style.display = 'none';

    // },
    // 图片上传失败的回调函数
    errorImage(err) {
      let _this = this;
      // _this.$Mint.Toast({message: '上傳失敗！登錄狀態失效'});
      // setTimeout(() => {
      //   _this.$router.push('/login')
      // },500)
    },
    // 图片上传超出限制的回调函数
    handleExceed() {
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳1張圖片！", "error", function() {
        _this.dialogVisible = false;
      });
    },
    // 图片列表发生改变的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.box-card {
  min-width: 400px;
  background: #fafafd;
  border-radius: 12px;
  margin-left: 200px;
  .cardHeader {
    height: 68px;
    background: #f2f2f6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 3px solid #e5e4ea;
    padding: 20px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    .cardHeaderLeft {
      font-size: 0.16rem;
      color: #6c3dea;
    }
    .cardHeaderRight_edit {
      padding: 5px 16px;
      border: 1px solid #6c3dea;
      border-radius: 4px;
      color: #6c3dea;
      cursor: pointer;
    }
  }
  .cardBody {
    padding: 20px;
    .cardRow {
      display: flex;
      .cardRowLeft {
        color: #938ea4;
        font-size: 0.14rem;
        text-align: left;
        width: 140px;
        flex-shrink: 0;
      }
      .allpointer {
        div {
          cursor: pointer !important;
        }
      }
      .cardRowRight {
        color: #292929;
        font-size: 0.14rem;
        text-align: left;
        word-break: break-all;
      }
      .cardRowRight_status {
        padding: 4px 8px;
        background: #6c3dea;
        color: #ffffff;
        font-size: 0.14rem;
        border-radius: 4px;
      }
      .coverbig {
        width: 80px;
        height: 80px;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        background: rgba(41, 41, 41, 1);
        opacity: 0.6;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.contentDetails {
  justify-content: flex-start;
  .detailsContent {
    width: 100%;

    .is-disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
      padding-left: 16px;
    }

    input:disabled {
      background-color: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
    }

    input.newsType {
      background: none;
      line-height: 40px;
      height: 40px;
      color: #606266;
    }

    .voucherBlock {
      display: flex;
      justify-items: start;
      align-items: center;

      .voucherWrap {
        // width: 1rem;
        // height: 1rem;
        .voucherImg {
          max-width: 3rem;
          // width: 1rem;
          // height: 1rem;
          display: block;
        }
      }

      .voucherWrap:first-child {
        margin-right: 20px;
      }

      span {
        display: inline-block;
        margin-left: 0.2rem;
        cursor: pointer;
      }
    }
  }

  .propWrap {
    .overseasAuth {
      width: 70%;
      height: 90%;
      background: #fff;
      border-radius: 0.06rem;

      .auth-box {
        padding: 0 2rem;
      }

      .prop-title {
        font-size: 0.14rem;
      }
    }

    i {
      padding: 0.1rem;
    }
  }

  input.overseasAreaCode {
    width: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userDetails.vue